// BASE LIBRAIRIES
import './init_Jquery';
import 'jquery-ui/dist/jquery-ui.min';
import Rails from '@rails/ujs';
import 'bootstrap/dist/js/bootstrap.bundle.min';

// EXTERNAL DEPENDENCIES
import 'intl-tel-input/build/js/intlTelInput-jquery.min';
import toastr from 'toastr';
import 'slick-carousel/slick/slick.min';

// CAPSENS HELPERS
import './channels/cable';
import './helpers';

// LIBRAIRIES
import './init_Select2';
import './pagy_init';

// PLATFORM JS CODE
import './address_autocomplete';
import './hide_show_password';
import './hide_show_ubo_beneficiary';
import './subscription_expiration';
import './distributors/change_distributor_form';
import './dashboard';
import './users/bank_account_toggle';
import './users/copy_to_clipboard';
import './users/document_status';
import './users/profile';
import './users/welcome_modal';

// STIMULUS
import './controllers';

Rails.start();

window.toastr = toastr;

$(document).ready(function () {
  $('.auto-input').on('change', function () {
    var form = $(this).parents('form')[0];

    Rails.fire(form, 'submit');
  })

  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    new bootstrap.Tooltip(tooltipTriggerEl)
  })

  $('body').on('change', '.file-input', function () {
    if ($(this)[0].files[0] !== undefined) {
      $(this)
        .parent().find(".label-wording")
        .html($(this)[0].files[0].name);
    }
  });

  // Prevent dropdown menu presents in responsive table from provoking unwanted scroll on responsive views.
  $('.table-responsive').on('show.bs.dropdown', function (e) {
    offset = $(e.relatedTarget).offset()

    heigth = $(e.relatedTarget).outerHeight()

    $(e.relatedTarget).next('.dropdown-menu').addClass('dropdown-menu-in-table').appendTo("body").css({ display: 'block', top: offset.top + heigth, left: offset.left });
  });

  $('body').on('hide.bs.dropdown', function (e) {
    $(this).find('.dropdown-menu-in-table').removeClass('dropdown-menu-in-table').css({ display: '', top: '', left: '' }).appendTo($(e.relatedTarget).parent());
  });
})
import * as bootstrap from "bootstrap"
